module.exports = __webpack_public_path__ + "static/media/location-disable.b80c1c47.svg";